import { render, staticRenderFns } from "./ControlPlanoModal.vue?vue&type=template&id=60058866&scoped=true"
import script from "./ControlPlanoModal.vue?vue&type=script&lang=js"
export * from "./ControlPlanoModal.vue?vue&type=script&lang=js"
import style0 from "./ControlPlanoModal.vue?vue&type=style&index=0&id=60058866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60058866",
  null
  
)

export default component.exports